module.exports = __webpack_public_path__ + "public/img/zanwu.47b3c975.png";